import React from 'react';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';

const Future = () => {
  return (
    <div className="future-page">
      <SEO 
        title="L'Avenir : SideLife | Nouveau Chapitre FiveM | ultraze.fr"
        description="Découvrez l'avenir de SideLife, le nouveau projet né de l'expérience Ultraze FA. Un chapitre construit avec des valeurs humaines, du respect et une vision renouvelée de la communauté FiveM RP. Rejoignez l'aventure gaming francophone."
        keywords="side life fivem, future ultraze fa, avenir projet fivem, side life avenir, nouveau chapitre fivem, projet gaming français, side life communauté, futur serveur fivem, side life développement, avenir rp gaming, side life vision, projet fivem sérieux, communauté gaming respectueuse, side life valeurs, futur ultraze fa, side life philosophie, développement serveur fivem, gaming community future, side life mission, avenir gaming francophone"
        url="/avenir"
        image="/logo.png"
        type="article"
      />
      <section className="future-section">
        <div className="container">
          <h2 className="section-title">L'AVENIR : <span className="highlight">SIDELIFE</span></h2>
          
          <div className="future-content">
            <div className="side-project">
              <h3>SIDE<span className="highlight">LIFE</span></h3>
              <p>
                Aujourd'hui, dans cette histoire hypothétique, le projet relancé ne représenterait 
                ni une revanche, ni une réponse directe à des événements passés. Il serait simplement 
                la continuité logique d'un parcours.
              </p>
              
              <div className="project-description">
                <p>
                  Un chapitre de plus, écrit avec davantage de lucidité et de prudence. 
                  Ce n'est pas une vengeance. Ce n'est pas un clash. C'est un nouveau départ, 
                  construit avec :
                </p>
              </div>

              <ul className="values-list">
                <li>
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Une équipe soudée</h4>
                    <p>Des relations humaines privilégiées et des collaborations authentiques</p>
                  </div>
                </li>
                <li>
                  <i className="fas fa-handshake"></i>
                  <div>
                    <h4>Des valeurs humaines</h4>
                    <p>Le respect des individus avant les intérêts matériels</p>
                  </div>
                </li>
                <li>
                  <i className="fas fa-heart"></i>
                  <div>
                    <h4>Du respect pour tous</h4>
                    <p>Joueurs, staff et communauté traités avec dignité</p>
                  </div>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <div>
                    <h4>Des promesses tenues</h4>
                    <p>Engagements clairs et respectés dans la durée</p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="philosophy-section">
              <h3>PHILOSOPHIE DU PROJET</h3>
              <div className="philosophy-content">
                <div className="philosophy-card">
                  <div className="philosophy-icon">
                    <i className="fas fa-brain"></i>
                  </div>
                  <h4>Réflexion et Recul</h4>
                  <p>
                    Construit avec plus de recul, plus d'expérience, et une attention 
                    particulière portée aux valeurs humaines.
                  </p>
                </div>

                <div className="philosophy-card">
                  <div className="philosophy-icon">
                    <i className="fas fa-shield-virus"></i>
                  </div>
                  <h4>Prévention et Protection</h4>
                  <p>
                    Des outils techniques mis en place non pour contraindre, 
                    mais comme forme d'assurance pour préserver les liens humains.
                  </p>
                </div>

                <div className="philosophy-card">
                  <div className="philosophy-icon">
                    <i className="fas fa-route"></i>
                  </div>
                  <h4>Continuité Logique</h4>
                  <p>
                    La continuité logique d'un parcours plutôt qu'une rupture violente. 
                    Un chapitre de plus dans une histoire en construction.
                  </p>
                </div>
              </div>
            </div>

            <div className="message-final">
              <blockquote>
                <p>
                  "Ce texte ne prétend pas détenir une vérité. Il ne désigne personne. 
                  Il n'affirme rien. Il propose seulement une lecture possible, 
                  volontairement incomplète."
                </p>
                <p>
                  "Certains éléments sont laissés flous, d'autres volontairement absents. 
                  Cette retenue n'est pas un manque de transparence, mais une nécessité."
                </p>
                <cite>— BLF | SideLife</cite>
              </blockquote>
            </div>

            <div className="call-to-action">
              <h3>REJOINDRE L'AVENTURE</h3>
              <p>
                Si tu es encore là aujourd'hui, ce n'est pas un hasard. 
                Et si tu décides de rester, retiens une chose : 
                ici, les promesses comptent. Ici, les humains passent avant l'ego. 
                Ici, on construit ensemble.
              </p>
              <div className="cta-buttons">
                <Link to="/histoire" className="btn btn-primary">
                  Relire l'histoire complète
                </Link>
                <a href="https://discord.gg/ZQh79htaUf" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <i className="fab fa-discord"></i> Rejoindre SideLife
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Future;